import { Fragment } from 'react';

import { Flex, GridItem, Skeleton } from '@tradener/lumen';

const ROWS = 10;

function CounterpartyListSkeleton() {
  return (
    <>
      {Array.from({ length: ROWS }).map((_, index) => (
        <Fragment key={`row-${index}`}>
          <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
            <Flex flexDir="column" gap="1.5" width="full">
              <Skeleton borderRadius="sm" isLoaded={false} width="80%" height="1rem" />
              <Skeleton borderRadius="sm" isLoaded={false} width="52%" height="0.85rem" />
            </Flex>
          </GridItem>
          <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
            <Skeleton borderRadius="sm" isLoaded={false} width="2.35rem" height="1.7rem" />
          </GridItem>
          <GridItem borderBottom="1px solid" borderColor="gray.100" py="3" px="3" display="flex" alignItems="center">
            <Skeleton borderRadius="sm" isLoaded={false} width="6.75rem" height="1rem" />
          </GridItem>
          <GridItem
            borderBottom="1px solid"
            borderColor="gray.100"
            py="3"
            px="3"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Skeleton borderRadius="sm" isLoaded={false} width="8.25rem" height="1rem" />
          </GridItem>
          <GridItem
            borderBottom="1px solid"
            borderColor="gray.100"
            py="3"
            px="3"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Skeleton borderRadius="sm" isLoaded={false} width="8.25rem" height="1rem" />
          </GridItem>
          <GridItem
            borderBottom="1px solid"
            borderColor="gray.100"
            py="3"
            px="3"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Skeleton borderRadius="sm" isLoaded={false} width="8.25rem" height="1rem" />
          </GridItem>
          <GridItem
            borderBottom="1px solid"
            borderColor="gray.100"
            py="3"
            px="3"
            display="flex"
            alignItems="center"
            justifyContent="flex-end"
          >
            <Skeleton borderRadius="sm" isLoaded={false} width="8.25rem" height="1rem" />
          </GridItem>
        </Fragment>
      ))}
    </>
  );
}

export default CounterpartyListSkeleton;
